import { render, staticRenderFns } from "./CellRendererActionsClient.vue?vue&type=template&id=10cbb236"
import script from "./CellRendererActionsClient.vue?vue&type=script&lang=js"
export * from "./CellRendererActionsClient.vue?vue&type=script&lang=js"
import style0 from "./CellRendererActionsClient.vue?vue&type=style&index=0&id=10cbb236&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports